<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-07-12 14:56:29
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-14 10:12:55
-->
<template>
  <div>
    <div class="mainbg">
      <!-- <img src="@/assets/images/home-bg.png" alt="" /> -->
      <div class="main_text_con">
        <div>多一门技能，多一扇窗，</div>
        <div>多一种可能，你的人生可能会不同</div>
      </div>
      <ul class="main_menu_con">
        <li v-for="(item, index) in listContent" :key="index">
          <label>{{ item.caption }}：</label><span>{{ item.desc }}</span>
        </li>
      </ul>
    </div>
    <div class="home_bottom">
      <div class="home_bottom_left">
        <div class="concat_title">
          <div class="concat_title_eng">Contact <span>us</span></div>
          <div>联系我们</div>
        </div>
        <div class="concat_icons">
          <div class="concat_icon_con">
            <img src="@/assets/images/concat-1.png" alt="" />
          </div>
          <div class="concat_icon_con">
            <img src="@/assets/images/concat-2.png" alt="" />
          </div>
          <div class="concat_icon_con">
            <img src="@/assets/images/concat-3.png" alt="" />
          </div>
        </div>
      </div>
      <div class="home_bottom_right t-a-r">
        <img src="@/assets/images/concat-code.png" alt="" />
        <div class="concat_info">
          加我微信
        </div>
        <div class="concat_info">fjjiao@goldensoftcn.com</div>
        <div class="concat_info">010-52861615</div>
        <div class="concat_info">北京•武汉</div>
      </div>
    </div>
    <div class="address_con">
      <div>
        京ICP备18009051号-1
      </div>
      <div class="t-a-r">
        <div>
          北京长未投资有限公司
        </div>
        <div style="margin-top:5px">
          北京市海淀区学院路甲5号2幢平房B北-2071室
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listContent: [
        {
          caption: "愿景",
          desc: "以科技为驱动力，为学习者提供帮助",
        },
        {
          caption: "价值观",
          desc: "加速学习，用好的方法最快达到目标",
        },
        {
          caption: "文化",
          desc: "自驱 自由",
        },
      ],
    };
  },
};
</script>
<style scoped>
*,
*:before,
*:after {
  box-sizing: border-box;
  outline: none;
}
ul {
  margin: 0;
}
@font-face {
  font-family: "MyFont";
  src: url("../assets/font/HYGuoQiangXingShuW.ttf");
}

.mainbg {
  position: relative;
  width: 100%;
  height: 1200px;
  background: url("../assets/images/home-bg.png") no-repeat center center/100%
    100%;
  /* background: linear-gradient(45deg, #446af1, #e478f7); */
}
.mainbg img {
  width: 100%;
  height: 100%;
}
.main_text_con {
  position: absolute;
  bottom: 120px;
  left: 150px;
  font-size: 70px;
  color: #fff;
  font-family: "MyFont";
}
.main_text_con div:first-child {
  margin-bottom: 10px;
}
.main_menu_con {
  position: absolute;
  top: 190px;
  right: 100px;
  color: #fff;
  font-size: 28px;
}
.main_menu_con li {
  padding: 8px 0;
}

.home_bottom {
  background: #fff;
  height: 660px;
  padding: 100px 160px 150px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.home_bottom_left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.concat_title {
  font-weight: bold;
  font-size: 24px;
}
.concat_title .concat_title_eng {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 5px;
}
.concat_title .concat_title_eng span {
  color: #f2b348;
  font-size: 24px;
  margin-left: 5px;
}
.home_bottom_left .concat_icons {
  display: flex;
}
.home_bottom_left .concat_icons .concat_icon_con {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #eeeeee;
  text-align: center;

  margin-right: 32px;
}
.home_bottom_left .concat_icon_con img {
  width: 32px;
  height: 32px;
  vertical-align: middle;
  margin-top: 3px;
}
.home_bottom_right img {
  width: 167px;
  height: 167px;
}
.home_bottom_right .concat_info {
  margin-top: 32px;
  font-size: 20px;
}
.address_con {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 240px;
  padding: 0 160px;
  background: #353535;
  color: #7b808e;
  font-size: 20px;
}
.t-a-r {
  text-align: right;
}
</style>
